import React from 'react';
import { STRIPE_PAYMENT_LINK } from '../config';
import './BottomCTA.css';

function BottomCTA() {
  return (
    <section className="bottom-cta" id="blog">
      <div className="bottom-cta-inner reveal">
        <h2>IN POLITICS,<br />NOTHING IS WHAT IT SEEMS</h2>
        <p>Start reading Saving Grace today.</p>
        <a href={STRIPE_PAYMENT_LINK} className="btn-red" target="_blank" rel="noopener noreferrer">Order Your Copy</a>
      </div>
    </section>
  );
}

export default BottomCTA;
